import { ICardProps } from "./Card"

/* Protopia Ecosystem component */ 

const CardTail = ({data, section, contentData, ...props}: ICardProps): JSX.Element => {
    return <div className="landing-card-tail">

    </div>
}
export default CardTail